import { render, staticRenderFns } from "./TaxManage.vue?vue&type=template&id=0e7b6cc2&"
import script from "./TaxManage.vue?vue&type=script&lang=js&"
export * from "./TaxManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports